import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processTimelog = (store, item) => {
    if (item.activity) {
        switch (item.activity_type) {
            case 'task':
                store.dispatch('processTask', item.activity)
                break;
            case 'work-type':
                store.dispatch('processWorkType', item.activity)
                break;
            case 'project-service':
                store.dispatch('processProjectService', item.activity)
                break;
        }
        delete item.activity
    }
    if (item.project) {
        store.dispatch('processProject', item.project)
        delete item.project
    }
    store.commit(mutations.ADD_OR_UPDATE_TIMELOG, item)
}

export const fetchTimelogs = (store, params = {}) => {
    return axios.get(`/api/timelogs`, {params})
        .then(res => {
            _.each(res.data.data, item => processTimelog(store, item))
            return res
        })
}

export const createTimelog = (store, item) => {
    return axios.post('/api/timelogs', item)
        .then(res => {
            processTimelog(store, res.data.data)
            return res
        })
}

export const updateTimelog = (store, item) => {
    return axios.patch(`/api/timelogs/${item.id}`, item)
        .then(res => {
            processTimelog(store, res.data.data)
            return res
        })
}

export const createOrUpdateTimelog = (store, item) => {
    return item.id ?
        updateTimelog(store, item) :
        createTimelog(store, item)
}

export const removeTimelog = (store, item) => {
    return axios.delete(`/api/timelogs/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_TIMELOG, item)
            return res
        })
}

export const openGlobalTimelog = (store, {project_id, activity_type = 'task', activity_id, closable, isShort = false, autoFill = false}) => {
    store.commit(mutations.OPEN_GLOBAL_TIMELOG, {project_id, activity_type, activity_id, closable, isShort, autoFill})
}

export const closeGlobalTimelog = store => {
    store.commit(mutations.CLOSE_GLOBAL_TIMELOG)
}